import type { DatePickerDesignTokens } from '@primeuix/themes/types/datepicker';

/**
 * DatePicker component tokens
 * 
 * Reference implementation:
 * https://github.com/primefaces/primeuix/blob/main/packages/themes/src/presets/aura/datepicker/index.ts
 * 
 * Component documentation:
 * https://primeng.org/datepicker
 */
export const datepickerComponentTokens: Partial<DatePickerDesignTokens> = {
  colorScheme: {
    light: {
      date: {
        selectedBackground: '{blue.500}',
        selectedColor: '{white}',
        rangeSelectedBackground: '{blue.500}',
        rangeSelectedColor: '{white}',
        focusRing: {
          color: '{blue.500}',
        },
      },
      inputIcon: {
        color: '{blue.500}',
      },
    },
  },
};

